"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callShippingAddressEndpoint = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function callShippingAddressEndpoint(shippingAddress, validate = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const prevShippingAddress = (0, checkout_frontend_library_1.getShippingAddress)();
        const isPrevEmpty = (0, src_1.isObjectEmpty)(prevShippingAddress);
        const isEmpty = (0, src_1.isObjectEmpty)(shippingAddress);
        const isEqual = (0, src_1.isObjectEquals)(prevShippingAddress, shippingAddress);
        let success = true;
        if (validate && !isEmpty && !isEqual) {
            success = yield (0, src_1.isAddressValid)(shippingAddress.first_name || '', shippingAddress.last_name || '', shippingAddress.address_line_1 || '', shippingAddress.address_line_2 || '', shippingAddress.city || '', shippingAddress.postal_code || '', shippingAddress.country_code || '', shippingAddress.province_code || '', 'shipping');
        }
        if (success) {
            if (isPrevEmpty && !isEqual) {
                return yield (0, checkout_frontend_library_1.setShippingAddress)(shippingAddress, src_1.API_RETRY);
            }
            else {
                if (!isEqual) {
                    return yield (0, checkout_frontend_library_1.updateShippingAddress)(shippingAddress, src_1.API_RETRY);
                }
                else {
                    success = true;
                }
            }
        }
        const error = !success ? new Error('Invalid Shipping Address') : null;
        return Object.assign(Object.assign({}, checkout_frontend_library_1.baseReturnObject), { success, error });
    });
}
exports.callShippingAddressEndpoint = callShippingAddressEndpoint;
